$(document).ready(function() {
  $('body').on('click','.ais-input-button', function(e) {
    e.preventDefault();
  })
  
  $('body').on('click', '.results-switcher ul a', function(e) {
    e.preventDefault();

    if(!$(this).hasClass('active')) {
      $('.results-switcher ul a').removeClass('active');
      $(this).addClass('active');

      if($(this).data('trigger') == "pages") {
        $('.results-count.count-products').hide();
        $('.results-count.count-pages').show();
        $('.ais-hits-container').hide();
        $('.ais-pagination-container').hide();
        $('.ais-hits-container-pages').show();
      } else {
        $('.results-count.count-products').show();
        $('.results-count.count-pages').hide();
        $('.ais-hits-container').show();
        $('.ais-pagination-container').show();
        $('.ais-hits-container-pages').hide();
      }
    }
  })
})
function searchCollectionsPages() {
  $.ajax({
  method: "POST",
  url: "https://"+algoliaShopify.config.app_id+"-dsn.algolia.net/1/indexes/*/queries?x-algolia-agent=Algolia%20for%20JavaScript%20(3.35.1)%3B%20Browser%20(lite)%3B%20instantsearch.js%20(4.5.0)%3B%20JS%20Helper%20(3.1.1)&x-algolia-application-id="+algoliaShopify.config.app_id+"&x-algolia-api-key="+algoliaShopify.config.search_api_key,
  data: '{"requests":[{"indexName":"pages","params":"clickAnalytics=true&facetingAfterDistinct=true&query='+document.querySelector('.ais-SearchBox-input').value+'&maxValuesPerFacet=10&highlightPreTag=%3Cspan%20class%3D%22ais-highlight%22%3E&highlightPostTag=%3C%2Fspan%3E&page=0&distinct=true"}]}'
  })
  .done(function( result ) {
    document.querySelector('.count-search-total-pages').innerHTML = result.results[0].nbHits;

    if(result.results[0].nbHits > 0) {
      $('.ais-hits-container-pages').empty();

      result.results[0].hits.forEach(function(item, index ) {
        $('.ais-hits-container-pages').append("<a href='/pages/"+item.handle+"' class='page-result'><h4>"+item.title+"</h4><div class='page-date'>"+item.published_at.split("T")[0]+"</div><div class='page-excerpt'>"+item.body_html_safe.trim().substring(0,250)+"&hellip;"+"</div></a>");
      });
    }
  });  

  $.ajax({
  method: "POST",
  url: "https://"+algoliaShopify.config.app_id+"-dsn.algolia.net/1/indexes/*/queries?x-algolia-agent=Algolia%20for%20JavaScript%20(3.35.1)%3B%20Browser%20(lite)%3B%20instantsearch.js%20(4.5.0)%3B%20JS%20Helper%20(3.1.1)&x-algolia-application-id="+algoliaShopify.config.app_id+"&x-algolia-api-key="+algoliaShopify.config.search_api_key,
  data: '{"requests":[{"indexName":"collections","params":"clickAnalytics=true&facetingAfterDistinct=true&query='+document.querySelector('.ais-SearchBox-input').value+'&maxValuesPerFacet=10&highlightPreTag=%3Cspan%20class%3D%22ais-highlight%22%3E&highlightPostTag=%3C%2Fspan%3E&page=0&distinct=true"}]}'
  })
  .done(function( result ) {
    document.querySelector('.count-search-total-collections').innerHTML = result.results[0].nbHits;

    if(result.results[0].nbHits > 0) {
      if($('.count-products .search-collections').length) {
        var search_collections = $('.count-products .search-collections');
      } else {
        $('.count-products').append("<div class='search-collections'></div>");
        var search_collections = $('.count-products .search-collections');
      }

      search_collections.empty();

      result.results[0].hits.forEach(function(item, index ) {
        search_collections.append("<a href='/collections/"+item.handle+"'>"+item.title+"</a>")
      });
    }
  });  
}